module.exports = __webpack_public_path__ + "img/userIcon.cb0ece30.png";